/*--------------------------------------------------------------------------\
  notifications.js

  Description
    The JavaScript side for notifications in Track.
    This file is included in header.ipp, and thus all Track pages.

  Copyrights- (C) Copyright 2007-2020 Software Consulting Services, LLC (SCS).
\--------------------------------------------------------------------------*/

( function () {

const CHAT_WIDTH = "350px";
const CHAT_HEIGHT = "500px";

var $j = jQuery;
var chatDefined = false;
var chatOpen = false;
var userId = -1;
var username = "";
var contact_list;
var contact_names;
var tempCList;

Date.prototype.getTimeStr = function () {
  var hours = this.getHours();
  var minutes = this.getMinutes();

  ampm = "AM";
  if ( hours > 12 ) {
    ampm = "PM";
    hours -= 12;
  } else if ( hours == 12 ) {
    ampm = "PM";
  }

  return ( "0" + hours ).substr( -2 ) + ":" + ( "0" + minutes ).substr( -2 ) + " " + ampm;
};

Date.prototype.getDateStr = function () {
  var month = this.getMonth() + 1;
  var day = this.getDate();
  var year = this.getFullYear();

  return ( "0" + month ).substr( -2 ) + "/" + ( "0" + day ).substr( -2 ) + "/" + year;
};

Date.prototype.isToday = function () {
  var d2 = new Date();
  if ( ( this.getMonth() == d2.getMonth() ) &&
       ( this.getDate() == d2.getDate() ) &&
       ( this.getYear() == d2.getYear() ) ) {
    return true;
  }

  return false;
}

function getMessageTimeStr( date ) {
  if ( date.isToday() ) {
    return date.getTimeStr();
  }

  return date.getDateStr();
}

function createMenuOption( title, action, parent ) {
  var el = document.createElement( "li" );
  el.style.padding = "5px";
  el.innerHTML = title;
  el.setAttribute( "data-action", action );

  $j( el ).mouseenter( function () {
    el.style.background = "#DDD";
  } );

  $j( el ).mouseleave( function () {
    el.style.background = "#FFF";
  } );

  parent.appendChild( el );
}

function createCustomMenu() {
  var customMenu = document.createElement( "ul" );
  customMenu.style.display = "none";
  customMenu.style.position = "absolute";
  customMenu.style.zIndex = "9999";
  customMenu.style.background = "#FFF";
  customMenu.style.border = "1px solid black";
  customMenu.style.borderRadius = "3px";
  customMenu.style.fontSize = "17px";
  customMenu.style.listStyleType = "none";
  customMenu.style.padding = "0px";
  customMenu.id = "customMenu";

  createMenuOption( "Open Chat", "open", customMenu );
  createMenuOption( "Delete Chat", "delete", customMenu );

  document.body.appendChild( customMenu );
  $j( document ).click( function ( e ) {
    $j( customMenu ).hide();
  } );

  $j( "#customMenu li" ).click( function () {
    switch( this.getAttribute( "data-action" ) ) {
      case "open":
        if ( !!tempCList ) {
          openChatMessages( tempCList );
        }
        break;
      case "delete":
        if ( !!tempCList ) {
          if ( confirm( "Are you sure you want to delete this chat?" ) ) {
            postJSON( "delete_message_from_cas", function () {
              viewMessages();
              }, {
              "cgi": "/cgi-bin/scs/all/spice.pl",
              "contact_list": tempCList
            }, null, "/cgi-bin/scs/all/spice.pl" );
          }
        }
        break;
    }

    $j( customMenu ).hide();
  } );
}

function startNewChat() {
  var data = [ {} ];

  var cList = [ userId ];
  var cNames = [ username ];
  $j( "#addContactsUL" ).children().each( function ( i, el ) {
    cList.push( el.value );
    cNames.push( el.name );
  } );

  data[ 0 ].contact_list = cList;
  data[ 0 ].contact_names = cNames;

  $j( "#addContactTable" ).hide();
  createChatWindow( data );
}

function addContact( contact, id ) {
  var exists = false;
  $j( "#addContactsUL" ).children().each( function ( i, el ) {
    if ( el.value == id )
      exists = true;
  } );

  if ( !exists ) {
    $j( "#startChatBtn" ).show();

    var li = document.createElement( "li" );
    li.style.fontSize = "15px";
    li.name = contact;
    $j( li ).attr( "value", id );
    $j( li ).html( contact );

    var deleteIcon = document.createElement( "i" );
    deleteIcon.className = "fa fa-times";
    deleteIcon.style.color = "red";
    deleteIcon.style.margin = "5px";

    $j( deleteIcon ).click( function () {
      $j( li ).remove();
      if ( !$j( "#addContactsUL" ).children().length ) {
        $j( "#startChatBtn" ).hide();
      }
    } );

    $j( li ).append( deleteIcon );
    $j( "#addContactsUL" ).append( li );
    $j( "#contactDropdown" ).val( "" );
  }
}

function createNewChat() {
  postJSON( "get_all_contacts_from_cas", function ( r ) {
    if ( !r.Response )
      return;

    var contactData = JSON.parse( r.JSONData );

    var addContactTable = document.createElement( "table" );
    addContactTable.id = "addContactTable";
    addContactTable.style.width = CHAT_WIDTH;

    var tr1 = document.createElement( "tr" );
    var td1 = document.createElement( "td" );
    var td1_2 = document.createElement( "td" );
    var td1_3 = document.createElement( "td" );
    var contactInput = document.createElement( "input" );
    contactInput.id = "contactDropdown";
    contactInput.style.margin = "10px";
    contactInput.setAttribute( "list", "contactData" );
    $j( contactInput ).change( function () {
      var contact = $j( contactInput ).val().trim();
      if ( !!contactData[ contact ] ) {
        addContact( contact, contactData[ contact ] );
      }
    } );

    var contactDatalist = document.createElement( "datalist" );
    contactDatalist.id = "contactData";

    var addContactBtn = document.createElement( "button" );
    addContactBtn.id = "addContactBtn";
    addContactBtn.style.width = "50px";
    addContactBtn.style.border = "1px solid black";
    addContactBtn.style.background = "#FFF";
    addContactBtn.style.boxShadow = "none";
    addContactBtn.style.borderRadius = "10px";
    addContactBtn.innerHTML = "Add";

    $j( addContactBtn ).click( function () {
      var contact = $j( contactInput ).val().trim();
      if ( !!contactData[ contact ] ) {
        addContact( contact, contactData[ contact ] );
      }
    } );

    var contactNames = Object.keys( contactData );
    contactNames.forEach( function ( n ) {
      if ( n.trim() != username.trim() ) {
        var contactOption = document.createElement( "option" );
        contactOption.value = n;
        contactDatalist.appendChild( contactOption );
      }
    } );

    td1.appendChild( contactInput );
    td1_2.appendChild( contactDatalist );
    td1_3.appendChild( addContactBtn );
    tr1.appendChild( td1 );
    tr1.appendChild( td1_2 );
    tr1.appendChild( td1_3 );
    addContactTable.appendChild( tr1 );

    var tr2 = document.createElement( "tr" );
    var td2 = document.createElement( "td" );
    td2.style.verticalAlign = "top";

    var ul = document.createElement( "ul" );
    ul.style.listStyleType = "none";
    ul.style.width = "200px";
    ul.style.height = "300px";
    ul.style.overflow = "hidden auto";
    ul.id = "addContactsUL";

    td2.appendChild( ul );
    tr2.appendChild( td2 );
    addContactTable.appendChild( tr2 );

    var tr3 = document.createElement( "tr" );
    var td3 = document.createElement( "td" );
    var startChatBtn = document.createElement( "button" );
    startChatBtn.id = "startChatBtn";
    startChatBtn.style.width = "50px";
    startChatBtn.style.border = "1px solid black";
    startChatBtn.style.background = "#FFF";
    startChatBtn.style.boxShadow = "none";
    startChatBtn.style.borderRadius = "10px";
    startChatBtn.style.float = "right";
    startChatBtn.style.display = "none";
    startChatBtn.innerHTML = "Go";

    $j( startChatBtn ).click( startNewChat );

    td3.appendChild( startChatBtn );
    tr3.appendChild( td3 );
    addContactTable.appendChild( tr3 );

    if ( !!$j( "#" + addContactTable.id ).length ) {
      $j( "#" + addContactTable.id ).replaceWith( addContactTable );
    } else {
      $j( "#chatWindow" ).append( addContactTable );
    }

    $j( "#msgUL" ).hide();
    $j( "#newChatBtn" ).hide();
    $j( "#chatBackBtn" ).show();
  }, { "cgi": "/cgi-bin/scs/all/spice.pl" }, null, "/cgi-bin/scs/all/spice.pl" );
}

function toggleInfo() {
  $j( "#chatBackBtn" ).toggle();
  $j( "#chatInfoBtn" ).html( ( $j( "#chatInfoBtn" ).html() == "X" ) ? "Info" : "X" );
  $j( "#chatMessageDiv" ).toggle();
  $j( "#sendTable" ).toggle();
  $j( "#infoDiv" ).toggle();
}

function viewMessages() {
  $j( "#addContactTable" ).hide();
  $j( "#chatBackBtn" ).hide();
  $j( "#chatInfoBtn" ).hide();
  $j( "#newChatBtn" ).show();
  $j( "#chatTitle" ).html( "Messages" );
  $j( "#chatMessageDiv" ).hide();
  $j( "#sendTable" ).hide();
  $j( "#msgUL" ).show();
  postJSON( "get_messages_from_cas", function ( r ) {
    if ( !r.Response )
      return;

    var ul = createMsgUL( r );
    $j( "#chatWindow ul" ).replaceWith( ul );
  }, { "cgi": "/cgi-bin/scs/all/spice.pl" }, null, "/cgi-bin/scs/all/spice.pl", (resp) => console.log(resp.Message) );
}

function sendChatMessage() {
  if ( $j( "#msgInput" ).val().trim() != "" ) {
    var tr = document.createElement( "tr" );
    var td = document.createElement( "td" );
    td.innerHTML = $j( "#msgInput" ).val()
    td.style.margin = "5px";
    td.style.padding = "5px";
    td.style.float = "right";
    td.style.background = "#03A9F4";
    td.style.border = "1px solid #03A9F4";
    td.style.borderBottomLeftRadius = "0px";
    td.style.borderRadius = "5px";
    td.style.fontSize = "15px";

    tr.appendChild( td );
    $j( "#chatMessageDiv table" ).append( tr );

    var chatMsgDiv = document.getElementById( "chatMessageDiv" );
    chatMsgDiv.scrollTo( 0, chatMsgDiv.scrollHeight );

    postJSON( "send_cas_message", null, {
      "cgi": "/cgi-bin/scs/all/spice.pl",
      "contact_list": contact_list.join( "," ),
      "contact_names": contact_names.join( "," ),
      "msg": $j( "#msgInput" ).val()
    }, null, "/cgi-bin/scs/all/spice.pl" );

    $j( "#msgInput" ).val( "" );
  }
}

function createChatWindow( data ) {
  contact_list = data[ 0 ].contact_list;
  contact_names = data[ 0 ].contact_names;

  $j( "#chatBackBtn" ).show();
  $j( "#newChatBtn" ).hide();
  $j( "#chatInfoBtn" ).show();
  var userRegex = new RegExp( username, "g" );
  $j( "#chatTitle" ).html( contact_names.join( "," ).replace( userRegex, "" ).replace( /^,|,$/g, "" ).replace( ",,", "," ) );
  if ( $j( "#chatTitle" ).html().length > 16 )
    $j( "#chatTitle" ).html( $j( "#chatTitle" ).html().substring( 0, 14 ) + "..." );

  var div = document.createElement( "div" );
  div.style.width = CHAT_WIDTH;
  div.style.height = parseInt( CHAT_HEIGHT ) - 130 + "px";
  div.style.overflowY = "auto";
  div.style.overflowX = "hidden";
  div.style.background = "#FFF";
  div.id = "chatMessageDiv";

  var table = document.createElement( "table" );
  table.style.width = parseInt( CHAT_WIDTH ) - 20 + "px";

  data.forEach( function ( chatObj, i ) {
    if ( chatObj.message != null ) {
      var chatEl = document.createElement( "td" );
      chatEl.innerHTML = chatObj.message;
      chatEl.style.margin = "5px";
      chatEl.style.padding = "5px";
      chatEl.style.fontSize = "15px";
      chatEl.style.borderRadius = "5px";

      var sender = chatObj.contact_names[ chatObj.contact_list.indexOf( chatObj.sender ) ];
      $j( chatEl ).attr( "title", "Sent by: " + sender );

      var senderColor = "#FFF";
      if ( parseInt( userId ) == parseInt( chatObj.sender ) ) {
        senderColor = "#03A9F4";
        chatEl.style.float = "right";
        chatEl.style.background = senderColor;
        chatEl.style.border = "1px solid " + senderColor;
        chatEl.style.borderBottomRightRadius = "0px";
      } else {
        chatEl.style.float = "left";
        chatEl.style.background = senderColor;
        chatEl.style.border = "1px solid black";
        chatEl.style.borderBottomLeftRadius = "0px";

        if ( ( ( i > 0 ) && ( data[ i - 1 ].sender != chatObj.sender ) ) ||
             ( ( i == 0 ) && ( parseInt( data[ i ].sender ) != parseInt( userId ) ) ) ) {
          var nameTR = document.createElement( "tr" );
          nameTR.innerHTML = sender;
          nameTR.style.paddingLeft = "5px";
          nameTR.style.fontSize = "12px";
          nameTR.style.fontWeight = "bold";
          table.appendChild( nameTR );
        }
      }

      var tr = document.createElement( "tr" );
      tr.appendChild( chatEl );
      table.appendChild( tr );
    }
  } );
  $j( "#msgUL" ).hide();

  div.appendChild( table );
  if ( !$j( "#" + div.id ).length ) {
    $j( "#chatWindow" ).append( div );
  } else {
    $j( "#" + div.id ).replaceWith( div );
  }

  var sendTable = document.createElement( "table" );
  sendTable.style.width = CHAT_WIDTH;
  sendTable.style.paddingTop = "5px";
  sendTable.style.paddingBottom = "5px";
  sendTable.style.background = "#FFF";
  sendTable.style.borderCollapse = "separate";
  sendTable.id = "sendTable";

  var tr = document.createElement( "tr" );
  var td1 = document.createElement( "td" );

  var input = document.createElement( "input" );
  input.style.width = "250px";
  input.style.marginLeft = "10px";
  input.placeholder = "Enter message...";
  input.id = "msgInput";

  $j( input ).keypress( function ( e ) {
    if ( e.keyCode == 13 )
      sendChatMessage();
  } );

  td1.appendChild( input );
  tr.appendChild( td1 );

  var td2 = document.createElement( "td" );
  var sendBtn = document.createElement( "button" );
  sendBtn.style.width = "25px";
  sendBtn.style.border = "none";
  sendBtn.style.background = "#FFF";
  sendBtn.style.boxShadow = "none";
  $j( sendBtn ).click( sendChatMessage );

  var sendIcon = document.createElement( "i" );
  sendIcon.className = "fa fa-arrow-right";

  sendBtn.appendChild( sendIcon );
  td2.appendChild( sendBtn );
  tr.appendChild( td2 );
  sendTable.appendChild( tr );

  if ( !$j( "#" + sendTable.id ).length ) {
    $j( "#chatWindow" ).append( sendTable );
  } else {
    $j( "#" + sendTable.id ).replaceWith( sendTable );
  }

  var infoDiv = document.createElement( "div" );
  infoDiv.style.width = CHAT_WIDTH;
  infoDiv.style.height = parseInt( CHAT_HEIGHT ) - 90 + "px";
  infoDiv.style.background = "#FFF";
  infoDiv.style.overflowY = "auto";
  infoDiv.style.overflowX = "hidden";
  infoDiv.style.display = "none";
  infoDiv.id = "infoDiv";

  var infoList = document.createElement( "ul" );
  infoList.style.listStyleType = "none";
  contact_names.forEach( function ( c ) {
    if ( c.trim() != username ) {
      var li = document.createElement( "li" );
      li.style.margin = "10px";
      li.innerHTML = c;
      infoList.appendChild( li );
    }
  } );

  infoDiv.appendChild( infoList );

  if ( !$j( "#" + infoDiv.id ).length ) {
    $j( "#chatWindow" ).append( infoDiv );
  } else {
    $j( "#" + infoDiv.id ).replaceWith( infoDiv );
  }

  div.scrollTo( 0, div.scrollHeight );
  postJSON( "update_read_status_from_cas", null, {
    "cgi": "/cgi-bin/scs/all/spice.pl",
    "contact_list": contact_list.join( "," )
  }, null, "/cgi-bin/scs/all/spice.pl" );
}

function openChatMessages( id ) {
  var data = {
    contact_list: id,
    cgi: "/cgi-bin/scs/all/spice.pl"
  };

  postJSON( "get_chat_messages_from_cas", function ( r ) {
    if ( !r.Response )
      return;

    createChatWindow( JSON.parse( r.JSONData ) );
  }, data, null, "/cgi-bin/scs/all/spice.pl" );
}

function setupTableEvents( table ) {
  $j( table ).mouseenter( function () { this.style.background = "#AAA"; } );

  $j( table ).mouseleave( function () { this.style.background = "#FFF"; } );

  $j( table ).click( function () { openChatMessages( table.id ); } );
}

function createMsgUL( data ) {
  userId = parseInt( data.userId );
  username = data.username;

  var ul = document.createElement( "ul" );
  ul.style.height = "400px";
  ul.style.overflowX = "hidden";
  ul.style.overflowY = "auto";
  ul.style.listStyleType = "none";
  ul.style.paddingInlineStart = "0px";
  ul.style.marginTop = "15px";
  ul.id = "msgUL";

  var messages = JSON.parse( data.JSONData );
  if ( !!messages.length ) {
    var sender, message, time;
    messages.reverse().forEach( function ( m ) {
      if ( !m.deleted_by || ( !!m.deleted_by && !m.deleted_by.includes( data.userId ) ) ) {
        var table = document.createElement( "table" );
        table.id = m.contact_list.join( "," );
        table.style.width = CHAT_WIDTH;
        table.style.padding = "10px 25px 10px 10px";
        table.style.background = "white";
        table.style.borderCollapse = "separate";
        setupTableEvents( table );

        var tr1 = document.createElement( "tr" );
        var tr2 = document.createElement( "tr" );

        if ( !m.read_by.includes( parseInt( data.userId ) ) ) {
          table.style.fontWeight = "800";
        }

        contact_list = m.contact_list;
        contact_names = m.contact_names;
        sender = contact_names[ contact_list.indexOf( m.sender ) ]
        time = new Date( m.time );

        var contactTD = document.createElement( "td" );
        var userRegex = new RegExp( username, "g" );
        contactTD.innerHTML = m.contact_names.join( "," ).replace( userRegex, "" ).replace( /^,|,$/g, "" ).replace( ",,", "," );
        if ( contactTD.innerHTML.length >= 38 )
          contactTD.innerHTML = contactTD.innerHTML.substring( 0, 35 ) + "...";
        contactTD.style.fontFamily = "Arial";
        contactTD.style.fontSize = "12px";
        tr1.appendChild( contactTD );

        var timeTD = document.createElement( "td" );
        timeTD.innerHTML = getMessageTimeStr( time );
        timeTD.style.float = "right";
        timeTD.style.fontFamily = "Arial";
        timeTD.style.fontSize = "12px";
        tr1.appendChild( timeTD );

        var messageTD = document.createElement( "td" );
        messageTD.innerHTML = sender + ": " + m.message;
        if ( m.sender == userId ) {
          var userStartRegex = new RegExp( "^" + username, "g" );
          messageTD.innerHTML = messageTD.innerHTML.replace( userStartRegex, "You" );
        }
        messageTD.style.fontFamily = "Arial";
        messageTD.style.fontSize = "12px";
        tr2.appendChild( messageTD );

        table.appendChild( tr1 );
        table.appendChild( tr2 );
        var li = document.createElement( "li" );
        $j( li ).bind( "contextmenu", function ( e ) {
          e.preventDefault();

          tempCList = this.firstChild.id;

          $j( "#customMenu" ).show();
          $j( "#customMenu" ).css( {
            top: e.pageY + "px",
            left: e.pageX + "px"
          } );
        } );
        li.appendChild( table );

        var hr = document.createElement( "hr" );
        hr.style.margin = "5px";
        li.appendChild( hr );
        ul.appendChild( li );
      }
    } );
  } else {
    var noMsgLI = document.createElement( "li" );
    noMsgLI.style.fontSize = "1.5em"
    noMsgLI.innerHTML = "No messages!";
    ul.appendChild( noMsgLI );
    ul.style.textAlign = "center";
  }

  return ul;
}

function toggleChat() {
  $j( "#newChatIcon" ).hide();

  if ( !chatDefined ) {
    chatDefined = true;

    var chatWindow = document.createElement( "div" );
    chatWindow.id = "chatWindow";
    chatWindow.style.width = CHAT_WIDTH;
    chatWindow.style.height = CHAT_HEIGHT
    chatWindow.style.bottom = "0px";
    chatWindow.style.right = "0px";
    chatWindow.style.position = "fixed";
    chatWindow.style.margin = "50px";
    chatWindow.style.zIndex = "9001";
    chatWindow.style.borderRadius = "15px";
    chatWindow.style.background = "#FFF";
    chatWindow.style.boxShadow = "#333 5px 5px 10px";

    var backBtn = document.createElement( "button" );
    backBtn.id = "chatBackBtn";
    backBtn.style.width = "25px";
    backBtn.style.border = "none";
    backBtn.style.boxShadow = "none";
    backBtn.style.background = "#FFF";
    backBtn.style.display = "none";

    var backBtnIcon = document.createElement( "i" );
    backBtnIcon.className = "fa fa-arrow-left";
    backBtn.appendChild( backBtnIcon );
    $j( backBtn ).click( viewMessages );

    var hiddenRefresh = document.createElement( "button" );
    hiddenRefresh.style.display = "none";
    hiddenRefresh.id = "hiddenRefreshBtn";
    $j( hiddenRefresh ).click( viewMessages );
    chatWindow.appendChild( hiddenRefresh );

    var title = document.createElement( "h3" );
    title.innerHTML = "Messages";
    title.id = "chatTitle";

    var newChatBtn = document.createElement( "button" );
    newChatBtn.id = "newChatBtn";
    newChatBtn.style.width = "50px";
    newChatBtn.style.border = "none";
    newChatBtn.style.boxShadow = "none";
    newChatBtn.style.background = "#FFF";
    newChatBtn.innerHTML = "New Chat";
    $j( newChatBtn ).click( createNewChat );

    var infoBtn = document.createElement( "button" );
    infoBtn.id = "chatInfoBtn";
    infoBtn.style.width = "50px";
    infoBtn.style.border = "none";
    infoBtn.style.boxShadow = "none";
    infoBtn.style.background = "#FFF";
    infoBtn.style.display = "none";
    infoBtn.innerHTML = "Info";
    $j( infoBtn ).click( toggleInfo );

    var titleTable = document.createElement( "table" );
    titleTable.style.background = "#FFF";
    titleTable.style.width = CHAT_WIDTH;
    titleTable.style.height = "40px";
    titleTable.style.marginTop = "15px";
    titleTable.style.borderTop = "2px solid black";
    titleTable.style.borderBottom = "2px solid black";

    var titleTR = document.createElement( "tr" );
    var titleTD1 = document.createElement( "td" );
    titleTD1.style.width = "20%";
    titleTD1.appendChild( backBtn );

    var titleTD2 = document.createElement( "td" );
    titleTD2.style.width = "60%";
    titleTD2.appendChild( title );

    var titleTD3 = document.createElement( "td" );
    titleTD3.style.width = "20%";
    titleTD3.appendChild( newChatBtn );
    titleTD3.appendChild( infoBtn );

    titleTR.appendChild( titleTD1 );
    titleTR.appendChild( titleTD2 );
    titleTR.appendChild( titleTD3 );
    titleTable.appendChild( titleTR );
    chatWindow.appendChild( titleTable );

    postJSON( "get_messages_from_cas", function ( r ) {
      if ( !r.Response )
        return;

      var ul = createMsgUL( r );
      chatWindow.appendChild( ul );
      chatOpen = true;
      document.body.appendChild( chatWindow );
    }, { "cgi": "/cgi-bin/scs/all/spice.pl" }, null, "/cgi-bin/scs/all/spice.pl", (resp) => console.log(resp.Message) );
  } else {
    chatOpen = !chatOpen;
    if ( chatOpen ) {
      postJSON( "get_messages_from_cas", function ( r ) {
        if ( !r.Response )
          return;

        var ul = createMsgUL( r );
        $j( "#chatWindow ul" ).replaceWith( ul );
        $j( "#chatWindow" ).toggle( chatOpen );
        $j( "#chatBackBtn" ).hide();
        $j( "#chatInfoBtn" ).hide();
        $j( "#newChatBtn" ).show();
      }, { "cgi": "/cgi-bin/scs/all/spice.pl" }, null, "/cgi-bin/scs/all/spice.pl", (resp) => console.log(resp.Message) );
    } else {
      $j( "#chatWindow" ).toggle( chatOpen );
      $j( "#chatMessageDiv" ).hide();
      $j( "#sendTable" ).hide();
      $j( "#chatTitle" ).html( "Messages" );
      $j( "#infoDiv" ).hide();
      $j( "#chatInfoBtn" ).html( "Info" );
      $j( "#addContactTable" ).hide();
    }
  }
}

function createChatBtn() {
  var chatBtn = document.createElement( "button" );
  chatBtn.style.width = "50px";
  chatBtn.style.height = "50px";
  chatBtn.style.bottom = "0px";
  chatBtn.style.right = "0px";
  chatBtn.style.position = "fixed";
  chatBtn.style.margin = "15px";
  chatBtn.style.zIndex = "1337";
  chatBtn.style.borderRadius = "100%";
  chatBtn.style.background = "#FFF"
  chatBtn.style.outline = "none";
  chatBtn.style.color = "#000";

  var stackSpan = document.createElement( "span" );
  stackSpan.className = "fa-stack fa-lg";

  var chatBtnIcon = document.createElement( "i" );
  chatBtnIcon.className = "fa fa-stack-2x fa-comment";

  var newChatIcon = document.createElement( "i" );
  newChatIcon.id = "newChatIcon";
  newChatIcon.className = "fa fa-stack-1x fa-exclamation fa-inverse";
  newChatIcon.style.display = "none";

  stackSpan.appendChild( chatBtnIcon );
  stackSpan.appendChild( newChatIcon );
  chatBtn.appendChild( stackSpan );
  document.body.appendChild( chatBtn );

  $j( chatBtn ).click( toggleChat );
}

var maxRecursion = 5;
function init() {
  var loggedIn = false;
  if ( maxRecursion-- > 0 ) {
    if ( !window.location.pathname.includes( "scs_bs" ) ) {
      if ( !!SessionManager().getUserName() ) {
        loggedIn = true;
      }
    } else {
      if ( JSON.stringify( SECURITY_PARAMS ) != "{}" ) {
        if ( !!SECURITY_PARAMS.UserName ) {
          loggedIn = true;
        }
      } else {
        setTimeout( init, 3000 );
        return;
      }
    }
  }

  var securityParams = getSecurityParams();
  if ( !securityParams ) {
    //Added because the pre-bootstrap user_mtn.ptn defines its own getSecurityParams() which doesn't return what we're looking for...
    var paramsElem = $( "security_params" ),
        paramsJSON = paramsElem ? getNodeAttribute( paramsElem, "data-security-params" ) : "{}";
    securityParams = parseJSON( paramsJSON );
  }

  if ( loggedIn && securityParams.ViewNotifications ) {
    postJSON( "get_notification_settings", ( r ) => {
      
      var showChatIcon = false;
      if ( !!r.settingsJSON ) {
        var userSettings = JSON.parse( r.settingsJSON );
        if ( typeof( userSettings.showChatIcon ) != "undefined" ) {
          showChatIcon = userSettings.showChatIcon;
        }
      }

      if ( showChatIcon ) {
        createChatBtn();
        createCustomMenu();
        var sessionId = getSecurityParams().SessionId;
        if ( !CASWebSocket || !CASWebSocket.isOpen() ) {
          if ( typeof( createNewCASWebSocket ) != "undefined" ) {
            createNewCASWebSocket();
          }
        }

        CASWebSocket.addNewCallback( { "event": "refresh_messages", "session_id": sessionId }, function () {
          if ( !!$j( "#chatWindow:visible" ).length ) {
            if ( !!$j( "#chatMessageDiv:visible" ).length ) {
              openChatMessages( contact_list.toString() );
            } else {
              $j( "#hiddenRefreshBtn" ).click();
            }
          } else {
            $j( "#newChatIcon" ).show();
          }
        } );

        postJSON( "get_messages_from_cas", function ( r ) {
          if ( !r.Response ) {
            return;
          }

          var newMessage = false;
          var messages = JSON.parse( r.JSONData );
          messages.forEach( function ( m ) {
            if ( !m.read_by.includes( parseInt( r.userId ) ) ) {
              newMessage = true;
            }
          } );

          if ( newMessage ) {
            $j( "#newChatIcon" ).show();
          }
        }, { "cgi": "/cgi-bin/scs/all/spice.pl" }, null, "/cgi-bin/scs/all/spice.pl", (resp) => console.log(resp.Message) );
      }
    }, { "cgi": "track_cgi" }, null, "/cgi-bin/scs/track/spice.pl" );
  }
}

if ( typeof( createNewCASWebSocket ) != "undefined" ) {
  $j( document ).ready( init );
} else {
  addSCSLoadEvent( init );
}

} ) ();
